import axios from 'axios';

const API_BASE_URL = "https://api.resumiprati.com.br/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export interface News {
  id: string;
  title: string;
  summary: string;
  image_url: string;
  source_url: string;
  published_at: string;
  slug: string;
}

export const fetchNews = async (): Promise<News[]> => {
  try {
    const response = await api.get('/news');
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar notícias:", error);
    throw error;
  }
};

export const fetchNewsBySlug = async (slug: string): Promise<News> => {
  try {
    const response = await api.get(`/news/${slug}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao buscar notícia com slug ${slug}:`, error);
    throw error;
  }
};
